import { render, staticRenderFns } from "./historywater.vue?vue&type=template&id=717fa203&scoped=true&"
import script from "./historywater.vue?vue&type=script&lang=js&"
export * from "./historywater.vue?vue&type=script&lang=js&"
import style0 from "./historywater.vue?vue&type=style&index=0&id=717fa203&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "717fa203",
  null
  
)

export default component.exports